module.exports = __webpack_public_path__ + "img/idm-intro-header_landscape.f0a508c3.jpg";